import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@/layout';
import { PolicyWrapper, CloseBtn } from './style';
import { LinkText, Text } from '../Typography/Text';
import useResize from '@/hooks/useResize';
import { getCookie, setCookie } from '@/utils/cookie';
import { Close } from '@/components/Icon';
import { useGetPolicyTerms } from '@/hooks/useGetPolicyTerms';
import { STATIC_TERMS_URL } from '@/utils/policyDocuments';

const CookiePolicy = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isMobile } = useResize();
  const { termsUrl, termsDate, initialized } = useGetPolicyTerms();
  const [acceptedTerms, setAcceptedTerms] = useState(() => {
    if (getCookie('cookiePolicy') !== 'true') return '';
    try {
      const stored = JSON.parse(getCookie('cookiePolicyDate') || '{}');
      return typeof stored?.terms === 'string' ? stored.terms : '';
    } catch {
      return '';
    }
  });
  const [active, setActive] = useState(false);
  // 等待版本解析完成，避免把空字串記成已同意版本，導致下一頁再次遮住表單。
  const needShowPolicy = initialized && !!termsDate && acceptedTerms !== termsDate;

  // 設定cookie的同意與否，並設定半年後過期
  const setCookiePolicy = (status: boolean) => {
    if (!initialized || !termsDate) return;
    setCookie('cookiePolicy', status ? 'true' : 'false', 180); // 180 days ~ 6 months
    setCookie('cookiePolicyDate', JSON.stringify({ terms: termsDate }), 180);
    setAcceptedTerms(status ? termsDate : '');
  };

  // 確認使用者是否有點擊同意，若有則隱藏cookie policy, 若無則顯示
  useEffect(() => {
    setActive(false);
    if (!needShowPolicy) return;
    const timer = setTimeout(() => setActive(true), 1500);
    return () => clearTimeout(timer);
  }, [needShowPolicy, termsDate]);

  const readiness = <span hidden data-testid="cookie-policy-status" data-ready={initialized} data-required={needShowPolicy} />;
  if (!needShowPolicy) return readiness;

  return (
    <>
      {readiness}
      <PolicyWrapper className={active ? 'active' : ''} isMobile={isMobile} >
        <div className="cover">
          <div className="content">
            <Flex alignItems={'center'} gridGap={20}>
              <Flex alignItems={'center'} gridGap={20}>
                <Text>
                  {t('cookiePolicy.content')}
                  <a target="_blank" rel="noreferrer" href={termsUrl || STATIC_TERMS_URL}>
                    <LinkText>{t('cookiePolicy.link')}</LinkText>
                  </a>
                </Text>
              </Flex>
            </Flex>
            <CloseBtn data-testid="cookie-policy-close" isMobile={isMobile} onClick={() => setCookiePolicy(true)}>
              <Close.CloseSVG />
            </CloseBtn>
          </div>
        </div>
      </PolicyWrapper>
    </>
  );
};

export default CookiePolicy;
